import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/converza_icon_only.svg'
import _imports_1 from '../assets/logo-converza.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-292538a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row h-screen w-screen fixed" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-[73px] w-[73px] mc:pt-4 mc:px-4 p-2 grow-from-margin",
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-52 h-[73px] p-4 duration-1000 reduce-from-margin",
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "pt-5 flex flex-col justify-center mb-3 gap-4 text-base" }
const _hoisted_11 = { class: "flex flex-col gap-4 w-full pb-4" }
const _hoisted_12 = { class: "overflow-y-auto w-full h-full" }

import SidebarLink from '../components/sidebar/SideBarLink.vue';

import { ref, onMounted } from 'vue';

import {
  CustomRouteRecordRaw,
  DEFAULT_BASE_DASHBOARD_NAME,
  routes,
} from '@/router';
import { useStore } from 'vuex';
import { CLEAR_AUTH, RETRIEVE_PARTNER } from '@/store';
import { AuthenticationError } from '@/http/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConverzaBaseView',
  setup(__props) {

const isMobile = () => {
  const userAgent = navigator.userAgent;
  const mobileDevices = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return mobileDevices.some((pattern) => pattern.test(userAgent));
};

const isCollapsed = ref(false);
const toggleSidebar = () => (isCollapsed.value = !isCollapsed.value);

const { dispatch, commit } = useStore();

onMounted(async () => {
  isCollapsed.value = isMobile();
  try {
    await dispatch(RETRIEVE_PARTNER);
  } catch (err) {
    if (err instanceof AuthenticationError) {
      commit(CLEAR_AUTH);
      return;
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar flex flex-col border-r-2 justify-between items-center h-full overflow-x-hidden shrink-0", {
        'w-16': isCollapsed.value,
        'w-52': !isCollapsed.value,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (isCollapsed.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes).find(
              (route) => route.name === _unref(DEFAULT_BASE_DASHBOARD_NAME)
            )?.children?.filter((route) => route?.ignoreOnNavbar !== true), (dashboardSubroutes) => {
            return (_openBlock(), _createBlock(SidebarLink, {
              key: dashboardSubroutes.path,
              to: dashboardSubroutes.name === 'Dashboard'
              ? '/dashboard'
              : `/dashboard/${dashboardSubroutes.path}`
              ,
              icon: (dashboardSubroutes as CustomRouteRecordRaw)?.icon ?? '',
              name: dashboardSubroutes.name?.toString() ?? '',
              collapsed: isCollapsed.value
            }, null, 8, ["to", "icon", "name", "collapsed"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(SidebarLink, {
          to: "/dashboard/ajuda",
          icon: "fa-regular fa-circle-question",
          name: "Ajuda",
          collapsed: isCollapsed.value
        }, null, 8, ["collapsed"]),
        _createVNode(SidebarLink, {
          to: "/dashboard/configuracoes",
          icon: "fas fa-gear",
          name: "Configurações",
          collapsed: isCollapsed.value
        }, null, 8, ["collapsed"]),
        _createVNode(SidebarLink, {
          collapsed: isCollapsed.value,
          variant: "button",
          icon: "fas fa-angle-double-left",
          name: "Fechar Menu",
          onClick: toggleSidebar,
          rotate: true
        }, null, 8, ["collapsed"])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})